module.exports = __webpack_public_path__ + "img/eye-close.e9631a0b.svg";